import React from 'react';
import { useTranslation } from 'react-i18next';
import { AVATARS, gameLogo, stadium } from './assets';
import { ME } from './data';

const K = 'caseStudies.worldCup.chrome';

// The game's mobile header: Header.css top row + the red SubHeader.
// The signed-in user is the fictional "me" row from the standings.
const AppChrome = ({ lang }) => {
  const { t } = useTranslation();
  return (
    <div className="hn" aria-hidden="true">
      <div className="hn-status" />
      <div className="hn-top">
        <span className="hn-menu">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </span>
        <img className="hn-logo" src={gameLogo} alt="" />
        <span className="hn-spacer" />
      </div>
      <div className="sh">
        <div className="sh-in">
          <div className="sh-user">
            <img className="sh-avatar" src={AVATARS[ME.avatar]} alt="" />
            <div className="sh-text">
              <span className="sh-greet">{t(`${K}.hi`)} <b>{ME[lang]}</b></span>
              <span className="sh-comm">
                <span>{t(`${K}.community`)}</span>
                <svg viewBox="0 0 12 12" fill="none" stroke="#FFF" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="2.5 4.5 6 8 9.5 4.5" />
                </svg>
              </span>
            </div>
          </div>
          <span className="sh-rank">{t(`${K}.rank`, { rank: 5 })}</span>
        </div>
      </div>
    </div>
  );
};

// A phone with the game's chrome on top; only `children` scrolls.
export const PhoneFrame = ({ lang, children }) => (
  <div className="phone">
    <div className="screen app">
      <div className="screen-wall" style={{ backgroundImage: `url(${stadium})` }} aria-hidden="true" />
      <div className="island" aria-hidden="true" />
      <AppChrome lang={lang} />
      <div className="screen-scroll">{children}</div>
    </div>
  </div>
);

// Leaderboard tab bar (Leaderboard.js TABS), decorative here.
export const LbTabs = ({ active }) => {
  const { t } = useTranslation();
  return (
    <div className="lb-tabs" aria-hidden="true">
      {['main', 'games', 'bonus'].map((id) => (
        <span key={id} className={`lb-tab${id === active ? ' on' : ''}`}>{t(`${K}.tabs.${id}`)}</span>
      ))}
    </div>
  );
};

// Caption above a phone (this page's words, not the game's).
export const DemoCaption = ({ title, note, children }) => (
  <figcaption className="demo-cap">
    <p className="demo-title">{title}</p>
    <p className="demo-note">{note}</p>
    {children}
  </figcaption>
);
